module.exports = __webpack_public_path__ + "static/media/b2w.addd50b2.png";